export default {
  INSTALL_SHELL_COMMANDS_RESULT: 'INSTALL_SHELL_COMMANDS_RESULT',
  OLD_IOS_APP_VERSION: 'OLD_IOS_APP_VERSION',
  OLD_ANDROID_APP_VERSION: 'OLD_ANDROID_APP_VERSION',
  START_LOADING: 'START_LOADING',
  STOP_LOADING: 'STOP_LOADING',
  PROGRESS: 'PROGRESS',
  DOWNLOAD: 'DOWNLOAD',
  DOWNLOAD_CLI_PROGRESS: 'DOWNLOAD_CLI_PROGRESS',
  RETRY_DOWNLOAD: 'RETRY_DOWNLOAD',
};
